import { PaymentMethod } from 'models/ChargeIntent'
import { Apiv2PaymentType } from 'models/Transaction'

const CHECKOUT_TO_APIV2_PAYMENT_TYPE_MAP: { [key: string]: Apiv2PaymentType } = {
  CC: Apiv2PaymentType.CC,
  Stripe: Apiv2PaymentType.CC,
  DW: Apiv2PaymentType.CC,
  ACH: Apiv2PaymentType.ACH,
  Plaid: Apiv2PaymentType.ACH,
  PayPal: Apiv2PaymentType.PAYPAL,
  PayPal_Commerce: Apiv2PaymentType.PAYPAL,
  Venmo: Apiv2PaymentType.VENMO,
}

const getApiv2PaymentType = (type: PaymentMethod) => CHECKOUT_TO_APIV2_PAYMENT_TYPE_MAP[type]

export default getApiv2PaymentType
